const $ = jQuery.noConflict();

export default function fadeInInit() {
    $(".fade-in").css("opacity", 1);
}
